import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { safeParse } from '../../utils/general/general';

export type HotelConfiguration = {
  data?: {
    address: string;
    lat?: number;
    lng?: number;
    name?: string;
    postcode?: string;
  };
  error?: unknown;
};

const subscribe = (callback: EventListener) => {
  window.addEventListener('config-change', callback);
  return () => {
    window.removeEventListener('config-change', callback);
  };
};

// Return the current value from the browser API
const getSnapshot = () => localStorage.getItem('config');

const useHotelConfig = () => {
  const unparsed = useSyncExternalStore(subscribe, getSnapshot);

  const hotelConfiguration = useMemo(() => safeParse(unparsed) as HotelConfiguration, [unparsed]);

  const setHotelConfiguration = useCallback((v: string | null) => {
    if (v === null) {
      localStorage.removeItem('config');
    } else {
      localStorage.setItem('config', v);
    }

    // The event name has to match the eventListeners defined in the subscribe function
    window.dispatchEvent(new StorageEvent('config-change'));
  }, []);

  return { hotelConfiguration, setHotelConfiguration };
};

export default useHotelConfig;
